var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow down"),React.createElement("g",{"id":"arrow-down","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polyline",{"id":"Path","stroke":"#E85633","strokeWidth":"2","points":"20.0173217 8 12.0104011 16.1160463 4 8.06039791"}))]);
}

Chevron.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Chevron;

Chevron.default = Chevron;
